import React, {FC} from "react"

import styled from "styled-components"
import {H1} from "@irati/ui/src/Typography"
import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"
import Link from "@irati/ui/src/Link"
import id from "@irati/utils/id"
import Flex from "@irati/ui/src/Flex"
import {walletTracking} from "@irati-tracking/wallet"
import Wallet from "../../images/wallet_badge.svg"
import {IntroText} from "../IntroText"
import Image from "../styled/Image"

const handleFaqsClick = () => {
  walletTracking.clickFaqs()
}

const Description = styled.div`
  display: none;
  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    display: block;
  `}
`

interface Props extends InjectIntl {}

const CashIntro: FC<Props> = (props) => {
  const {formatMessage} = props
  const idNamespace = id("intro", props)

  return (
    <>
      <Flex id={id("header", idNamespace)} alignItems="center">
        <Image src={Wallet} alt="" />
        <H1>
          <FormattedMessage id="wallet.intro.header" />
        </H1>
      </Flex>
      <Description>
        <IntroText message="wallet.intro.description" />
        <Link
          onClick={handleFaqsClick}
          id={id("faq-link", idNamespace)}
          href={formatMessage({id: "wallet.intro.faq.link.href"})}
          target="_blank">
          <FormattedMessage id="wallet.intro.faq.link.text" />
        </Link>
      </Description>
    </>
  )
}

export default injectIntl(CashIntro)
